// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_MatrixResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/service_priorities/matrix
 *
 * Nested key-value matrix for frontend consumption.
 * Wire shape: `dados: { [service_id]: { [priority_id]: ServicePriorities_MatrixCellRow } }`
 *
 * The keys are dynamic integer IDs (service_id outer, priority_id inner), but
 * every leaf cell shares the fixed ServicePriorities_MatrixCellRow shape, so dados
 * projects to Record<number, Record<number, ServicePriorities_MatrixCellRow>> in TS
 * (the consumer's matrix[sid][pid] lookup is preserved — only the leaf is typed).
 */
import type { ServicePriorities_MatrixCellRow } from './ServicePriorities_MatrixCellRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServicePriorities_MatrixResponseDados = ServicePriorities_MatrixCellRow[][];

export type ServicePriorities_MatrixResponse = ApiResponse<ServicePriorities_MatrixResponseDados>;

registerResponseContract('ServicePriorities_MatrixResponse', {})
